const pages = {
  dashboard: {
    title: "Дашборд",
    description: "Обзор проектов, документов и последней активности",
  },
  appLauncher: {
    title: "Все приложения",
    description: "Главный экран — все приложения, виджеты и инструменты в одном месте",
  },
  layers: {
    title: "Хаб",
    description: "Командный хаб — статистика, активность, графики и быстрый доступ",
  },
  vcards: {
    title: "vCards",
    description: "Все экземпляры и типы сущностей в одном месте — единый список, каталог типов и редактор",
  },
  editor: {
    title: "Редактор",
    description: "Документ-редактор Tiptap — Фаза 2",
  },
  storyMap: {
    title: "vStory",
    description: "Доска vStory с перетаскиванием — Фаза 3",
  },
  functionalMap: {
    title: "Функциональная карта",
    description: "Функциональная карта GAM — 3 уровня × 5 функций с инлайн-редактированием",
  },
  aiHub: {
    title: "AI Центр",
    description: "AI-ассистент с 5 режимами работы — Чат, Анализ, Написание, Декомпозиция и Менеджер задач",
  },
  aiHome: {
    title: "Дом AI",
    description: "Единая точка входа в каталог агентов, возможностей, промптов и памяти",
  },
  aiAdvisors: {
    title: "AI Советники",
    description: "18 экспертов-консультантов в различных областях — выбор персоны и прямой чат",
  },
  designSystem: {
    title: "Дизайн-система",
    description: "Галерея дизайнов — просмотр, редактирование и вдохновение",
  },
  architecture: {
    title: "Архитектура",
    description: "Диаграмма Mermaid + таблица инструментов — карта архитектуры vBrain.io",
  },
  plan: {
    title: "План",
    description: "Дорожная карта из 5 фаз — таймлайн со статусами и маршрутами",
  },
  settings: {
    title: "Настройки",
    description: "Язык, тема и профиль бренда",
  },
  automations: {
    title: "Центр автоматизации",
    description: "Панель управления подключениями, задачами, вебхуками и быстрыми действиями",
  },
  control: {
    title: "Центр управления",
    description: "Обзор — дорожная карта, журнал разработки, архитектура и последние обновления",
  },
  siteControl: {
    title: "gam.co.il · Управление сайтом",
    description: "Карта сайта, источники, поиск и публикация в одном месте",
  },
  admin: {
    title: "Журнал разработки",
    description: "Обзор системы, компоненты и отслеживание версий",
  },
  adminDataBrain: {
    title: "Данные и мозг",
    description: "Внутренний админ-слой Refine поверх данных Supabase",
  },
  serverHealth: {
    title: "Состояние сервера",
    description: "Мониторинг состояния сервера в реальном времени — системные ресурсы, Docker контейнеры и сервисы",
  },
  entities: {
    title: "Сущности",
    description: "Система сущностей и глобальных полей — всё начинается с записки",
  },
  entityFields: {
    title: "Библиотека полей",
    description: "Глобальные поля для повторного использования",
  },
  wiki: {
    title: "Вики",
    description: "База знаний бизнеса — ИИ учится из неё понимать ваши потребности",
  },
  entityTypes: {
    title: "Типы сущностей",
    description: "Шаблоны, определяющие поля для каждого типа записи",
  },
  grid: {
    title: "Таблица",
    description: "Электронная таблица с формулами, окраской ячеек и экспортом CSV",
  },
  slides: {
    title: "Слайды",
    description: "Конструктор презентаций с фоновыми изображениями, текстом и фигурами",
  },
  boardroom: {
    title: "Совет",
    description: "Мульти-персональная консультационная панель — 8 AI-экспертов",
  },
  feeds: {
    title: "RSS-ленты",
    description: "Новости строительства и недвижимости из ведущих израильских источников",
  },
  import: {
    title: "Импорт",
    description: "Импорт файлов CSV/Excel в систему сущностей",
  },
  matching: {
    title: "Движок сопоставления",
    description: "AI-сопоставление сущностей — работники, проекты, подрядчики и лиды",
  },
  roadmap: {
    title: "Дорожная карта",
    description: "Бизнес-иерархия — цели, портфели, проекты, спринты и задачи",
  },
  comms: {
    title: "Коммуникация",
    description: "Все сообщения, звонки и переписки в одном месте",
  },
  documents: {
    title: "Документы",
    description: "Договоры, цифровые подписи и архив документов",
  },
  weeklyPlanner: {
    title: "Недельный планировщик",
    description: "Недельное планирование, ежедневные задачи и повторяющиеся шаблоны",
  },
  audit: {
    title: "Журнал аудита",
    description: "Отслеживание всех изменений и действий в системе — юридические доказательства",
  },
  emailTemplates: {
    title: "Дизайнер email шаблонов",
    description: "Редактор шаблонов email — редактирование, динамические переменные и предпросмотр",
  },
  vcanvas: {
    title: "vCanvas",
    description: "Свободная доска — скетчи, диаграммы и визуальные идеи",
  },
  toolkit: {
    title: "Инструменты",
    description: "Инструменты для разработки, ИИ и программы",
  },
  courses: {
    title: "Библиотека курсов",
    description: "Персональные курсы с транскрипциями, резюме и карточками для обучения",
  },
  maintenance: {
    title: "Обслуживание кода",
    description: "Профессиональная система мониторинга и обслуживания качества кода",
  },
  knowledge: {
    title: "База знаний",
    description: "Управление корпоративными знаниями и поиск — источник истины для организационной информации",
  },
  researchLibrary: {
    title: "Библиотека исследований",
    description: "Внешние источники, которым мы доверяем — кто автор, когда проверено и что мы решили",
  },
  knowledgeSources: {
    title: "Полка источников",
    description: "Каждый источник знаний и что из него собрано — книги, вики, беседы и опыт GAM",
  },
  systemMonitoring: {
    title: "Мониторинг системы",
    description: "Дашборд мониторинга производительности системы и метрик в реальном времени",
  },
  honeypot: {
    title: "Ловушки-приманки",
    description: "Тихие ловушки: что активно, когда последняя проверка и что попалось",
  },
  iconLibrary: {
    title: "Библиотека иконок",
    description: "Централизованное управление иконками, эмодзи и цветами для всех приложений и папок",
  },
  vault: {
    title: "vPassword",
    description: "Хранилище секретов, ключей и паролей — 1Password как источник истины, аудит дрейфа по всем средам",
  },
  cost: {
    title: "Контроль расходов",
    description: "Контроль бюджета и расходов по всем платным сервисам — лимиты, пороги и оповещения",
  },
  health: {
    title: "Здоровье системы",
    description: "Единый обзор всех живых источников здоровья — автоматизации, интеграции, статус разработки, соединения, сервер и входящие задачи",
  },
  identityResolver: {
    title: "Resolver организаций и подрядчиков",
    description: "Источники, правила и SQL-контракт до подключения движка",
  },
} as const;
export default pages;
